<template>
  <div class="coach-list-table" v-loading="loading">
    <el-table
      ref="table"
      row-key="id"
      v-if="rows && rows.length > 0"
      :data="rows"
      @sort-change="doChangeSort"
    >

      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <!-- Name -->
      <el-table-column sortable="custom" :resizable="false" :label="i18n('entities.coach.fields.name')" :width="250">
        <template slot-scope="scope">
          <el-tooltip
            :disabled="!hasPermissionToAuditLogs"
            effect="dark"
            :content="scope.row.id"
            placement="bottom"
          >
            <span
              class="list__avatar__name"
              v-if="scope.row.firstName && scope.row.lastName"
              v-text="`${presenter(scope.row, 'firstName')} ${presenter(scope.row, 'lastName')}`"
            />
            <span v-else v-text="'-'" />
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- <el-table-column
        :label="fields.gender.label"
        :prop="fields.gender.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'gender') }}</template>
      </el-table-column> -->

      <!-- <el-table-column
        :label="fields.country.label"
        :prop="fields.country.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'country') }}</template>
      </el-table-column> -->

      <el-table-column
        :label="fields.type.label"
        :prop="fields.type.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'type') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.teams.label"
        :prop="fields.teams.name"
      >
        <template slot-scope="scope">
          <app-i18n
            v-if="!scope.row.teams || !scope.row.teams.length"
            code="common.none"
          />
          <span
            v-else-if="scope.row.teams.length === 1"
            v-text="scope.row.teams[0].name"
          />

          <el-tooltip
            v-else
            effect="dark"
            :content="scope.row.teams.map(team => team.name).join('\n')"
            placement="bottom"
          >
            <app-i18n code="entities.team.list.multipleTeams" />
          </el-tooltip>

        </template>
      </el-table-column>

      <el-table-column
        :label="fields.email.label"
        :prop="fields.email.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'email') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.lastLogin.label"
        :prop="fields.lastLogin.name"
        :resizable="false"
        :width="170"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.lastLogin"
            v-text="presenter(scope.row, 'lastLogin')"
          />
          <app-i18n
            v-else
            code="common.never"
          />
        </template>
      </el-table-column>

      <!-- <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.lastLogin"
            v-text="presenter(scope.row, 'lastLogin')"
          />
          <app-i18n
            v-else
            code="common.never"
          />
        </template>
      </el-table-column> -->

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="140">
        <template slot-scope="scope">
          <div class="table-actions">
            <!-- <router-link :to="`/coach/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link> -->

            <router-link :to="`/iam/coaches/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button
              icon="icon-pen"
              circle
              />
            </router-link>

            <!-- <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              v-if="hasPermissionToDestroy"
              icon="icon-trash"
            /> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <app-empty-page
      v-else
      :icon-class="'icon-family'"
      :empty-text="i18n('entities.coach.empty')"
    />

    <div class="el-pagination-wrapper" v-if="rows && rows.length > 0">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      />
    </div>
  </div>
</template>

<script>
import { CoachModel } from '@modules/coach/coach-model';
import { mapGetters, mapActions } from 'vuex';
import { CoachPermissions } from '@modules/coach/coach-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';

import { i18n } from '@shared/i18n';

export default {
  name: 'app-coach-list-table',

  mounted() {
    this.doFetch();
  },

  computed: {
    ...mapGetters({
      rows: 'coach/list/rows',
      count: 'coach/list/count',
      loading: 'coach/list/loading',
      pagination: 'coach/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'coach/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new CoachPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new CoachPermissions(this.currentUser).destroy;
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).fields();
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'coach/list/doChangeSort',
      doChangePaginationCurrentPage: 'coach/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'coach/list/doChangePaginationPageSize',
      doMountTable: 'coach/list/doMountTable',
      doDestroy: 'coach/destroy/doDestroy',
      doFetch: 'coach/list/doFetch',
    }),

    presenter(row, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style>
.coach-list-table .el-table__row {
  cursor: default;
}
</style>
